import { PaymentGatewayIntegration } from '../..';

import cvc from './elements/cvc.vue';
import creditCard from './elements/creditCard.vue';
import expiry from './elements/expiry.vue';
import Wrapper from '@/Render';

export default class Stripe extends PaymentGatewayIntegration {
    public name = 'Stripe';
    public scriptUrl = 'https://js.stripe.com/v3/';
    public fields = {
        cvc,
        creditCard,
        expiry,
    };

    public integrationFields = {
        elements: Function,
        stripe: {},
    };

    constructor(vm: Wrapper, settings: any) {
        super(vm, settings);

        this.isCvcOptional = true;
    }

    public async created() {
        await this.loadScript();
        if (!window.Stripe) {
            this.vm.failed = true;
        }

        if (!window.StripeInited) {
            const options: any = {};
            if (this.integrationData.property_account) {
                options.stripeAccount = this.integrationData.property_account;
            }
            if (this.integrationData.api_version) {
                options.apiVersion = this.integrationData.api_version;
            }
            window.StripeInited = window.Stripe(
                this.integrationData.publishable_key,
                options,
            );
        }
        this.integrationFields.stripe = window.StripeInited;
        this.integrationFields.elements = (this.integrationFields.stripe as any).elements({
            locale: 'auto',
        });

        this.vm.loading = false;
    }

    public async serialize(additionalsGot: any) {
        const keyMatch = {
            exp_year: 'expiry',
            exp_month: 'expiry',
            number: 'creditCard',
            cvc: 'cvc',
        };

        const additionals = this.preSerialize(additionalsGot);
        const card = (this.vm.$refs.creditCard as any).cardNumber;
        const data = await (this.integrationFields.stripe as any).createToken(card, { ...additionals });
        const { token } = data;
        if (token) {
            return this.postSerialize(additionalsGot, {
                token_data: token.id,
                token_card: token.card,
            });
        } else {
            const validation = this.vm.validate(true);
            if (data.error.param) {
                const key = keyMatch[data.error.param];
                validation.isValid = false;
                validation.validation[key] = false;
                validation.commonError = data.error.message;
                (this.vm.$refs[key] as any).valid = false;
                (this.vm.$refs[key] as any).$emit('valid', false);
            } else {
                validation.isValid = false;
                validation.commonError = data.error.message;
            }
            throw validation;
        }
    }
}
